<template>
  <div>
    <my-loader v-if="isLoading"></my-loader>
    <div v-else class="content">
      <div class="change-item-block">
        <div class="change-item-block-button">
          <button @click="templateSend('driver')">Водители</button>
          <button @click="templateSend('car')">Автомобили</button>
          <button @click="templateSend('trailer')">Прицепы</button>
        </div>
        <font-awesome-icon class="icon" icon="fa-solid fa-arrow-up" />
        <p style="font-size:14px;">Выбрать список</p>
      </div>
      <div class="lists-container">
        <div class="list">
          <h2>Кандидаты</h2>
          <div v-for="item in itemList" :key="item.id" @click="toggleItem(item, 'list1')" 
          :class="{'small':true, 'selected-green': isSelected('list1', item) }">
            <div v-if="item.number">{{ item.number }}</div>
            <div v-else>{{ item.first_name }} - {{ item.phone }}</div>
          </div>
        </div>
        <div class="controls">
          <button 
          class="add-button"
          @click="moveItems(false)">Добавить
          <font-awesome-icon class="icon" icon="fa-solid fa-arrow-right" />
          </button>
          <button 
          class="delete-button"
          @click="moveItems(true)">
          <font-awesome-icon class="icon" icon="fa-solid fa-arrow-left" />
          Удалить
        </button>
        </div>
        <div class="list">
          <h2>Шаблоны</h2>
          <div v-for="item in itemTemplate" :key="item.id" @click="toggleItem(item, 'list2')" :class="{ 'selected-red': isSelected('list2', item) }">
            <div v-if="item.number">{{ item.number }}</div>
            <div class="small" v-else>{{ item.first_name }} - {{ item.phone }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import ApiAdminConnector from '@/backend/apiModels/admin';

export default {
  name: 'TempaleTmsCandidate',
  setup() {
    const api = new ApiAdminConnector();

    const itemTemplate = ref(null);
    const itemList = ref(null);
    const selectedItems = ref([]);
    const isLoading = ref(false);
    const selecterModel = ref(null)

    const templateSend = async (name) => {
      selecterModel.value = name
      const { request, response } = api.get({ model: 'tms-template?name='+name, params: {} });
      isLoading.value = true
      await request()
      isLoading.value = false
      if (response.value) {
        itemTemplate.value = response.value.template
        itemList.value = response.value.list
      }
    }

    const toggleItem = (item) => {
      const id = selectedItems.value.push(item.id);
    }

    const moveItems = async(drop) => {
      const form = {
        drop,
        ids:selectedItems.value,
        model:selecterModel.value
      }
      const { request, response } = api.put({ model: 'tms-template?name='+name, form });
      isLoading.value = true
      await request()
      isLoading.value = false
      if (response.value) {
        itemTemplate.value = response.value.template
        itemList.value = response.value.list
      } 
      selectedItems.value = [];
    };

    const isSelected = (listName, item) => {
      return selectedItems.value.includes(item.id)
    };


    return {
      templateSend,
      itemTemplate,
      itemList,
      isLoading,
      selectedItems,
      toggleItem,
      moveItems,
      isSelected,
    };
  },
};
</script>

<style scoped>
.small{
  font-size: 14px;
}

.lists-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.list {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  width: 200px;
  height: 300px;
  overflow-y: auto;
}

.list div {
  cursor: pointer;
  margin: 5px 0;
}

.list h2{
  border-bottom: 1px solid;
}

.selected-green {
  background-color: lightgreen;
}

.selected-red {
  background-color: lightcoral;
}

.controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 10px;
}

button {
  margin: 5px;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100px;
}

.add-button{
  background-color: #007bff;
  color: #fff;
}

.delete-button{
  margin-top: 30px;
  background-color: #b60018;
  color: #fff;
}

.icon{
  margin-top: 2px;

}

.change-item-block{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.change-item-block-button{
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(182,0,24, 0.5);
  padding: 3px;

}
</style>
